module.exports = __webpack_public_path__ + "img/payPull.1194b6c8.svg";